"use strict";
/*
 * CODEX-MODIFIED: the contents of this file were written by a human and modified after the fact by a Codex agent.
*/
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _BoardElement_element, _BoardElement_selector, _CountdownContainerElement_element, _CountdownContainerElement_selector, _ControlsElement_element, _ControlsElement_whiteClockElement, _ControlsElement_blackClockElement, _ControlsElement_selector, _PlayerTypeElement_element, _PlayerTypeElement_computerButton, _PlayerTypeElement_humanButton, _PlayerTypeElement_selector, _CancelButtonElement_selector, _CancelButtonElement_element, _ConnectionStatusElement_selector, _ConnectionStatusElement_element, _ConfettiElement_selector, _ConfettiElement_element, _ConfettiElement_hideTimer;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfettiElement = exports.ConnectionStatusElement = exports.CancelButtonElement = exports.PlayerTypeElement = exports.ControlsElement = exports.fadePieces = exports.CountdownContainerElement = exports.BoardElement = void 0;
class BoardElement {
    get element() {
        return __classPrivateFieldGet(this, _BoardElement_element, "f");
    }
    constructor() {
        _BoardElement_element.set(this, void 0);
        _BoardElement_selector.set(this, '#board');
        const element = document.querySelector(__classPrivateFieldGet(this, _BoardElement_selector, "f"));
        if (!element)
            throw new Error(`Cannot find ${__classPrivateFieldGet(this, _BoardElement_selector, "f")}.`);
        __classPrivateFieldSet(this, _BoardElement_element, element, "f");
    }
    disable() {
        __classPrivateFieldGet(this, _BoardElement_element, "f").style.pointerEvents = 'none';
    }
    enable() {
        __classPrivateFieldGet(this, _BoardElement_element, "f").style.pointerEvents = 'auto';
    }
}
exports.BoardElement = BoardElement;
_BoardElement_element = new WeakMap(), _BoardElement_selector = new WeakMap();
class CountdownContainerElement {
    get element() {
        return __classPrivateFieldGet(this, _CountdownContainerElement_element, "f");
    }
    constructor(whoMovesFirst) {
        _CountdownContainerElement_element.set(this, void 0);
        _CountdownContainerElement_selector.set(this, '#countdown-container');
        const parent = document.querySelector('#board');
        const element = document.createElement('div');
        element.id = __classPrivateFieldGet(this, _CountdownContainerElement_selector, "f").replace('#', '');
        const top = document.createElement('div');
        top.textContent = `${whoMovesFirst} moves first`;
        top.style.fontSize = '2rem';
        top.style['-webkit-text-stroke'] = '1px black';
        const bottom = document.createElement('div');
        bottom.textContent = 'Get ready...';
        bottom.style.fontSize = '2rem';
        top.style['-webkit-text-stroke'] = '1px black';
        element.appendChild(top);
        element.appendChild(bottom);
        parent.prepend(element);
        fadePieces(whoMovesFirst, true);
        __classPrivateFieldSet(this, _CountdownContainerElement_element, element, "f");
    }
    hide(whoMovesFirst) {
        __classPrivateFieldGet(this, _CountdownContainerElement_element, "f").remove();
        fadePieces(whoMovesFirst, false);
    }
    setCountdownText(text) {
        const bottom = document.querySelector('#countdown-container :nth-child(2)');
        bottom.innerText = text.toString();
    }
}
exports.CountdownContainerElement = CountdownContainerElement;
_CountdownContainerElement_element = new WeakMap(), _CountdownContainerElement_selector = new WeakMap();
function fadePieces(playerColor, on = true) {
    const board = document.querySelector('#board');
    if (on) {
        board.dataset.countdownColor = playerColor;
    }
    else {
        delete board.dataset.countdownColor;
    }
}
exports.fadePieces = fadePieces;
class ControlsElement {
    get element() {
        return __classPrivateFieldGet(this, _ControlsElement_element, "f");
    }
    constructor() {
        _ControlsElement_element.set(this, void 0);
        _ControlsElement_whiteClockElement.set(this, void 0);
        _ControlsElement_blackClockElement.set(this, void 0);
        _ControlsElement_selector.set(this, '#controls');
        const element = document.querySelector(__classPrivateFieldGet(this, _ControlsElement_selector, "f"));
        if (!element)
            throw new Error(`Cannot find ${__classPrivateFieldGet(this, _ControlsElement_selector, "f")}`);
        __classPrivateFieldSet(this, _ControlsElement_element, element, "f");
        const whiteClockElement = document.querySelector('#white-clock');
        if (!whiteClockElement)
            throw new Error('Cannot find #white-clock');
        __classPrivateFieldSet(this, _ControlsElement_whiteClockElement, whiteClockElement, "f");
        const blackClockElement = document.querySelector('#black-clock');
        if (!blackClockElement)
            throw new Error('Cannot find #black-clock');
        __classPrivateFieldSet(this, _ControlsElement_blackClockElement, blackClockElement, "f");
    }
    setTime(whiteTime, blackTime) {
        __classPrivateFieldGet(this, _ControlsElement_whiteClockElement, "f").innerHTML =
            '<div>' + (whiteTime > 0 ? whiteTime : 0).toFixed(1) + 's</div>';
        __classPrivateFieldGet(this, _ControlsElement_blackClockElement, "f").innerHTML =
            '<div>' + (blackTime > 0 ? blackTime : 0).toFixed(1) + 's</div>';
    }
    setActive(color) {
        var _a, _b, _c, _d;
        (_b = (_a = __classPrivateFieldGet(this, _ControlsElement_whiteClockElement, "f").parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('img')) === null || _b === void 0 ? void 0 : _b.classList.toggle('is-turn', color === 'white');
        (_d = (_c = __classPrivateFieldGet(this, _ControlsElement_blackClockElement, "f").parentElement) === null || _c === void 0 ? void 0 : _c.querySelector('img')) === null || _d === void 0 ? void 0 : _d.classList.toggle('is-turn', color === 'black');
    }
    clearActive() {
        var _a, _b, _c, _d;
        (_b = (_a = __classPrivateFieldGet(this, _ControlsElement_whiteClockElement, "f").parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('img')) === null || _b === void 0 ? void 0 : _b.classList.remove('is-turn');
        (_d = (_c = __classPrivateFieldGet(this, _ControlsElement_blackClockElement, "f").parentElement) === null || _c === void 0 ? void 0 : _c.querySelector('img')) === null || _d === void 0 ? void 0 : _d.classList.remove('is-turn');
    }
}
exports.ControlsElement = ControlsElement;
_ControlsElement_element = new WeakMap(), _ControlsElement_whiteClockElement = new WeakMap(), _ControlsElement_blackClockElement = new WeakMap(), _ControlsElement_selector = new WeakMap();
class PlayerTypeElement {
    get element() {
        return __classPrivateFieldGet(this, _PlayerTypeElement_element, "f");
    }
    constructor() {
        _PlayerTypeElement_element.set(this, void 0);
        _PlayerTypeElement_computerButton.set(this, void 0);
        _PlayerTypeElement_humanButton.set(this, void 0);
        _PlayerTypeElement_selector.set(this, '#player-type-panel');
        const element = document.querySelector(__classPrivateFieldGet(this, _PlayerTypeElement_selector, "f"));
        if (!element)
            throw new Error(`Cannot find ${__classPrivateFieldGet(this, _PlayerTypeElement_selector, "f")}.`);
        __classPrivateFieldSet(this, _PlayerTypeElement_element, element, "f");
        const computerButton = document.querySelector('#player-type-computer');
        const humanButton = document.querySelector('#player-type-human');
        if (!computerButton || !humanButton) {
            throw new Error('Cannot find player type buttons.');
        }
        __classPrivateFieldSet(this, _PlayerTypeElement_computerButton, computerButton, "f");
        __classPrivateFieldSet(this, _PlayerTypeElement_humanButton, humanButton, "f");
    }
    hide() {
        __classPrivateFieldGet(this, _PlayerTypeElement_element, "f").style.display = 'none';
    }
    show() {
        __classPrivateFieldGet(this, _PlayerTypeElement_element, "f").style.display = '';
    }
    setSelection(value) {
        switch (value) {
            case 'computer':
                __classPrivateFieldGet(this, _PlayerTypeElement_computerButton, "f").classList.add('is-selected');
                __classPrivateFieldGet(this, _PlayerTypeElement_humanButton, "f").classList.remove('is-selected');
                break;
            case 'human':
                __classPrivateFieldGet(this, _PlayerTypeElement_humanButton, "f").classList.add('is-selected');
                __classPrivateFieldGet(this, _PlayerTypeElement_computerButton, "f").classList.remove('is-selected');
                break;
            default:
                throw new Error(`Invalid player type: ${value}.`);
        }
    }
    setPending(value) {
        __classPrivateFieldGet(this, _PlayerTypeElement_computerButton, "f").disabled = true;
        __classPrivateFieldGet(this, _PlayerTypeElement_humanButton, "f").disabled = true;
        __classPrivateFieldGet(this, _PlayerTypeElement_element, "f").dataset.pending = value !== null && value !== void 0 ? value : '';
    }
    clearPending() {
        __classPrivateFieldGet(this, _PlayerTypeElement_computerButton, "f").disabled = false;
        __classPrivateFieldGet(this, _PlayerTypeElement_humanButton, "f").disabled = false;
        delete __classPrivateFieldGet(this, _PlayerTypeElement_element, "f").dataset.pending;
    }
    onComputerClick(handler) {
        __classPrivateFieldGet(this, _PlayerTypeElement_computerButton, "f").addEventListener('click', handler);
    }
    onHumanClick(handler) {
        __classPrivateFieldGet(this, _PlayerTypeElement_humanButton, "f").addEventListener('click', handler);
    }
}
exports.PlayerTypeElement = PlayerTypeElement;
_PlayerTypeElement_element = new WeakMap(), _PlayerTypeElement_computerButton = new WeakMap(), _PlayerTypeElement_humanButton = new WeakMap(), _PlayerTypeElement_selector = new WeakMap();
class CancelButtonElement {
    get element() {
        return __classPrivateFieldGet(this, _CancelButtonElement_element, "f");
    }
    constructor() {
        _CancelButtonElement_selector.set(this, '#cancel-button');
        _CancelButtonElement_element.set(this, void 0);
        const element = document.querySelector(__classPrivateFieldGet(this, _CancelButtonElement_selector, "f"));
        if (!element)
            throw new Error(`Cannot find ${__classPrivateFieldGet(this, _CancelButtonElement_selector, "f")}.`);
        __classPrivateFieldSet(this, _CancelButtonElement_element, element, "f");
    }
    show() {
        __classPrivateFieldGet(this, _CancelButtonElement_element, "f").style.display = '';
    }
    hide() {
        __classPrivateFieldGet(this, _CancelButtonElement_element, "f").style.display = 'none';
    }
}
exports.CancelButtonElement = CancelButtonElement;
_CancelButtonElement_selector = new WeakMap(), _CancelButtonElement_element = new WeakMap();
class ConnectionStatusElement {
    get element() {
        return __classPrivateFieldGet(this, _ConnectionStatusElement_element, "f");
    }
    constructor() {
        _ConnectionStatusElement_selector.set(this, '#connection-status');
        _ConnectionStatusElement_element.set(this, void 0);
        const element = document.querySelector(__classPrivateFieldGet(this, _ConnectionStatusElement_selector, "f"));
        if (!element)
            throw new Error(`Cannot find ${__classPrivateFieldGet(this, _ConnectionStatusElement_selector, "f")}.`);
        __classPrivateFieldSet(this, _ConnectionStatusElement_element, element, "f");
    }
    show(message, tone = 'info') {
        __classPrivateFieldGet(this, _ConnectionStatusElement_element, "f").textContent = message;
        __classPrivateFieldGet(this, _ConnectionStatusElement_element, "f").dataset.tone = tone;
        __classPrivateFieldGet(this, _ConnectionStatusElement_element, "f").style.visibility = 'visible';
    }
    clear() {
        __classPrivateFieldGet(this, _ConnectionStatusElement_element, "f").textContent = '';
        __classPrivateFieldGet(this, _ConnectionStatusElement_element, "f").dataset.tone = 'info';
        __classPrivateFieldGet(this, _ConnectionStatusElement_element, "f").style.visibility = 'hidden';
    }
}
exports.ConnectionStatusElement = ConnectionStatusElement;
_ConnectionStatusElement_selector = new WeakMap(), _ConnectionStatusElement_element = new WeakMap();
class ConfettiElement {
    get element() {
        return __classPrivateFieldGet(this, _ConfettiElement_element, "f");
    }
    constructor() {
        _ConfettiElement_selector.set(this, '#confetti-stage');
        _ConfettiElement_element.set(this, void 0);
        _ConfettiElement_hideTimer.set(this, void 0);
        const element = document.querySelector(__classPrivateFieldGet(this, _ConfettiElement_selector, "f"));
        if (!element)
            throw new Error(`Cannot find ${__classPrivateFieldGet(this, _ConfettiElement_selector, "f")}.`);
        __classPrivateFieldSet(this, _ConfettiElement_element, element, "f");
    }
    show() {
        if (__classPrivateFieldGet(this, _ConfettiElement_hideTimer, "f") !== undefined) {
            window.clearTimeout(__classPrivateFieldGet(this, _ConfettiElement_hideTimer, "f"));
            __classPrivateFieldSet(this, _ConfettiElement_hideTimer, undefined, "f");
        }
        __classPrivateFieldGet(this, _ConfettiElement_element, "f").classList.remove('is-fading');
        __classPrivateFieldGet(this, _ConfettiElement_element, "f").style.display = 'flex';
        window.setTimeout(() => {
            __classPrivateFieldGet(this, _ConfettiElement_element, "f").classList.add('is-fading');
            __classPrivateFieldSet(this, _ConfettiElement_hideTimer, window.setTimeout(() => {
                __classPrivateFieldGet(this, _ConfettiElement_element, "f").style.display = 'none';
                __classPrivateFieldGet(this, _ConfettiElement_element, "f").classList.remove('is-fading');
                __classPrivateFieldSet(this, _ConfettiElement_hideTimer, undefined, "f");
            }, 500), "f");
        }, 1000);
    }
}
exports.ConfettiElement = ConfettiElement;
_ConfettiElement_selector = new WeakMap(), _ConfettiElement_element = new WeakMap(), _ConfettiElement_hideTimer = new WeakMap();
